import React from 'react';
import PropTypes from 'prop-types';

import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import {styled} from '@mui/system';

import {PREVIEW_COUNT_M, MAX_RESULT_COUNT} from '../../settings';


const StyledMoreLessButton = styled(Button)({
     marginTop: 5
});


class PreviewAndAll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open_details: false
        };

        this.previewCount = this.props.previewCount || PREVIEW_COUNT_M;
    }

    handleDetailsClick = () => {
        this.setState({open_details: !this.state.open_details});
    };

    cutOffInfo = () => {
        return <i>The list was reduced to {MAX_RESULT_COUNT} items</i>;
    };

    showMoreData = () => {
        if(this.props.data.length > this.previewCount){
            return (
                <div>
                    <Collapse in={this.state.open_details} timeout="auto" unmountOnExit>
                        {this.props.dataDisplayCallable(this.props.data.slice(this.previewCount, MAX_RESULT_COUNT))}
                        {this.props.data.length >= MAX_RESULT_COUNT && this.cutOffInfo() }
                    </Collapse>
                    <StyledMoreLessButton
                        size="small"
                        onClick={this.handleDetailsClick}>
                        {this.state.open_details ? 'less...' : 'more...'}
                    </StyledMoreLessButton>
                </div>
            );
        }
    };

    render() {
        if(this.props.data && this.props.data.length > 0){
            return (
                <div>
                    {this.props.dataDisplayCallable(this.props.data.slice(0, this.previewCount))}
                    {this.showMoreData()}
                </div>
            );
        }
        return <span/>;
    }
}


PreviewAndAll.propTypes = {
    data: PropTypes.array,
    dataDisplayCallable: PropTypes.func.isRequired,
    previewCount: PropTypes.number
};

export default PreviewAndAll;


